import { BrowserRouter } from "react-router-dom";
import { SessionBootstrapProvider } from "../shared/session/SessionBootstrapProvider";
import { AppRouter } from "./router";

export function App() {
  return (
    <BrowserRouter>
      <SessionBootstrapProvider>
        <AppRouter />
      </SessionBootstrapProvider>
    </BrowserRouter>
  );
}
